import script from "./FlappySnek.vue?vue&type=script&setup=true&lang=js"
export * from "./FlappySnek.vue?vue&type=script&setup=true&lang=js"

import "./FlappySnek.vue?vue&type=style&index=0&id=68ddf671&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68ddf671"]])

export default __exports__